const buildProvidersTree = (componentsWithProps) => {
  const initialComponent = ({ children }) => <>{children}</>;

  return componentsWithProps.reduce((AccumulatedComponents, [Provider, props = {}]) => {
    // eslint-disable-next-line react/display-name
    return ({ children }) => (
      <AccumulatedComponents>
        <Provider {...props}>{children}</Provider>
      </AccumulatedComponents>
    );
  }, initialComponent);
};

export { buildProvidersTree };
